import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center text-background-50 font-heading font-black text-base">
                91
              </span>
              <span className="font-heading font-black text-xl text-background-50">
                吃瓜
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200/80 max-w-md">
              91吃瓜是面向中文娱乐爱好者的资讯门户，聚焦娱乐新闻、明星动态与网络热点，
              用清晰的结构和轻快的阅读节奏，帮你第一时间掌握娱乐圈风向。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a
                href="#"
                aria-label="微博"
                className="w-9 h-9 rounded-md bg-background-50/10 hover:bg-primary-500 flex items-center justify-center text-background-100 transition-colors cursor-pointer"
              >
                <i className="ri-weibo-fill" />
              </a>
              <a
                href="#"
                aria-label="微信"
                className="w-9 h-9 rounded-md bg-background-50/10 hover:bg-primary-500 flex items-center justify-center text-background-100 transition-colors cursor-pointer"
              >
                <i className="ri-wechat-fill" />
              </a>
              <a
                href="#"
                aria-label="抖音"
                className="w-9 h-9 rounded-md bg-background-50/10 hover:bg-primary-500 flex items-center justify-center text-background-100 transition-colors cursor-pointer"
              >
                <i className="ri-tiktok-fill" />
              </a>
              <a
                href="#"
                aria-label="邮箱"
                className="w-9 h-9 rounded-md bg-background-50/10 hover:bg-primary-500 flex items-center justify-center text-background-100 transition-colors cursor-pointer"
              >
                <i className="ri-mail-line" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading font-bold text-base text-background-50">内容频道</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              {categories.map((cat) => (
                <li key={cat.key}>
                  <Link
                    to={cat.path}
                    className="text-background-200/80 hover:text-primary-300 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-bold text-base text-background-50">关于平台</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link
                  to="/about"
                  className="text-background-200/80 hover:text-primary-300 transition-colors cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-background-200/80 hover:text-primary-300 transition-colors cursor-pointer"
                >
                  联系我们
                </Link>
              </li>
              <li>
                <Link
                  to="/search"
                  className="text-background-200/80 hover:text-primary-300 transition-colors cursor-pointer"
                >
                  搜索资讯
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-200/70">
            © {year} 91吃瓜 · 本站内容为演示数据，仅供浏览参考
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs text-background-200/70">
            <span className="whitespace-nowrap">友情链接</span>
            <a href="#" className="hover:text-primary-300 cursor-pointer whitespace-nowrap">光影周刊</a>
            <a href="#" className="hover:text-primary-300 cursor-pointer whitespace-nowrap">综艺观察站</a>
            <a href="#" className="hover:text-primary-300 cursor-pointer whitespace-nowrap">星闻速递</a>
          </div>
        </div>
      </div>
    </footer>
  );
}